import React, { FC, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import styles from 'styles/components/template.module.scss'
import text from 'styles/utility/text.module.scss'
import { RedLogo } from 'components/Image'
import { Spacer } from 'components/Utility'
import { Checkbox, TextInput } from 'components/Form'
import { useCheckbox, useStringChangeEvent, useToggleBoolean } from 'hooks/form'
import { OrangeButton } from 'components/Button'
import { signIn } from 'reducks/auth/operations'
import { push } from 'connected-react-router'
import { State } from 'index'
import { getEmailError, getPasswordError } from 'reducks/error/selectors'
import { isValidEmailFormat } from 'reducks/error/operations'
import { initErrorAction } from 'reducks/error/actions'
import { getIsSignedIn } from 'reducks/auth/selectors'

const LoginTemplate: FC = () => {
  const dispatch = useDispatch()
  const emailError = useSelector((state: State) => getEmailError(state))
  const passwordError = useSelector((state: State) => getPasswordError(state))
  const isSignedIn = useSelector((state: State) => getIsSignedIn(state))

  // ブラウザバックなどでログインページに戻ってきた際、ログイン済みならトップページへ遷移する
  useEffect(() => {
    if (!isSignedIn) return
    dispatch(push('/'))
  }, [isSignedIn])

  const [email, setEmail] = useState<string>('')
  const [password, setPassword] = useState<string>('')
  const [isAutoLogin, setAutoLogin] = useState<string[]>([])
  const [isHidden, setIsHidden] = useState<boolean>(true)

  const handleEmail = useStringChangeEvent(setEmail)
  const handlePassword = useStringChangeEvent(setPassword)
  const handleAutoLogin = useCheckbox(setAutoLogin)
  const toggleIsHidden = useToggleBoolean(setIsHidden)

  return (
    <div className={styles.login}>
      <RedLogo />
      <Spacer size={32} />
      <TextInput
        date-testid={'email'}
        disabled={false}
        error={emailError}
        isFilled={email !== ''}
        onChange={handleEmail}
        onBlur={() => dispatch(isValidEmailFormat(email))}
        required={true}
        placeholder={'メールアドレス'}
        type={'email'}
        value={email}
      />
      <Spacer size={12} />
      <TextInput
        date-testid={'password'}
        disabled={false}
        error={passwordError}
        icon={isHidden ? '/icon/show_password.svg' : '/icon/hide_password.svg'}
        isFilled={password !== ''}
        onChange={handlePassword}
        onClick={toggleIsHidden}
        required={true}
        placeholder={'パスワード'}
        type={isHidden ? 'password' : 'text'}
        value={password}
      />
      <Spacer size={20} />
      <Checkbox
        dataCy={'autoLogin'}
        id={'autoLogin'}
        isChecked={isAutoLogin.includes('autoLogin')}
        label={'次回から自動的にログイン'}
        onChange={handleAutoLogin}
      />
      <Spacer size={32} />
      <OrangeButton
        disabled={email === '' || password === '' || password.length < 6}
        label={'ログイン'}
        onClick={() => dispatch(signIn(email, password, isAutoLogin.includes('autoLogin')))}
        size={'medium'}
        type={'main'}
      />
      <Spacer size={32} />
      <a
        className={`${text.link} ${text.align_center}`}
        role={'button'}
        onClick={() => {
          dispatch(push('/forget'))
          dispatch(initErrorAction())
        }}
      >
        パスワードをお忘れの方はこちら
      </a>
    </div>
  )
}

export default LoginTemplate
